import axios from 'axios'
export default {
  sendEmail ({state, commit}, token) {
    return new Promise((resolve, reject) => {
      commit('toggleLoadingEmail', true)
      axios({
        method: 'post',
        url: process.url + 'Hotsite/DontHaveAccess',
        timeout: 200000,
        headers: {
          'Token': token
        },
        data: state
      })
      .then((response) => {
        commit('toggleLoadingEmail', false)
        resolve(true)
      })
      .catch((error) => {
        if (error.request.response !== '') {
          var erros = JSON.parse(error.request.response).preErros
          var description = ''
          if (erros.length > 0) {
            erros.forEach(element => {
              description = description + ' ' + element
            })
          } else {
            description = erros[0]
          }
          if (erros !== undefined) {
            commit('toastr', {
              color: 'error',
              texto: description
            })
          }
        }
        commit('toggleLoadingEmail', false)
        commit('toastrAxiosError', error, { root: true })
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/cantAccess/actions.js